'use client';

// Este componente não é mais usado - a funcionalidade foi movida para o menu de 3 pontinhos
// Mantido apenas para compatibilidade, mas não renderiza nada
export function InjectPollButton() {
  // Funcionalidade movida para MoreOptionsButton
  return null;
}